import apiClient from '@/clients/apiClient';

export const getAssetSecureLink = (assetId) =>
  apiClient.get('assets', { params: { assetId } });


